import Vue from 'vue';
import Router from 'vue-router';
import Index from '../components/Index';
import About from "@/views/about/About";
import Connect from "@/views/connect/Connect";
import Detail from "../views/detail/Detail";
import Cases from "../views/cases/Cases";
import Supply from "../views/supply/Supply";
import Video from "../views/video/Video";
import Main from "../views/Main/Main";
import Business from "../views/business/Business";

Vue.use(Router);

// 跳转错误信息提示
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  // 正式环境将history打开
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'video',
      component: Video
    },
    {
      path: '/index',
      name: 'Main',
      component: Main,
      children: [
        {
          path: 'index',
          name: 'Index',
          component: Index
        },
        {
          path: "about",
          name: 'About',
          component: About
        },
        {
          path: 'connect',
          name: 'Connect',
          component: Connect
        },
        {
          path: 'detail',
          name: 'Detail',
          component: Detail
        },
        {
          path: 'cases',
          name: 'Cases',
          component: Cases
        }, {
          path: 'supply',
          name: 'Supply',
          component: Supply
        },{
          path: 'business',
          name: 'business',
          component: Business
        }
      ]
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js